import React from 'react';
import { withRouter, Switch, Route, Redirect } from 'react-router-dom';

//HELPERS
import $ from 'jquery';
import * as c from '../helpers/constants'
import { callApi } from '../helpers/methods'

//REDUX
import { connect } from 'react-redux';
//import { bindActionCreators } from 'redux';
//import { authActionsPrivate } from '../store/auth';

//LAYOUT
import PrivateLayout from '../layouts/private'

//COMPONENTS
import Error404 from './error404';
import EnvioSimples from '../components/relatorio/envioSimples';
import EnvioRastreado from '../components/relatorio/envioRastreado';
import EnvioVerificaMontreal from '../components/relatorio/envioVerificaMontreal';
import envioVerificaMontrealToi from '../components/relatorio/envioVerificaMontrealToi';
import Graficos from '../components/relatorio/graficos';
import downloadLaudo from '../components/carimboTempo/downloadLaudo';
import downloadRelatorio from '../components/relatorio/downloadRelatorio';

class Relatorio extends React.PureComponent
{
    constructor(props)
    {
        super(props);
    }

    render()
    {
        return (            
            <PrivateLayout navActiveItem={c.NAV_REPORT}>

                <Switch history={this.props.history}>                           
                    <Redirect exact from={c.REPORT_ROUTE} to={c.REPORT_ROUTE+"/envio-rastreado"} />
                    
                    <Route exact path={c.REPORT_ROUTE+"/envio-simples"} component={EnvioSimples} />
                    <Route exact path={c.REPORT_ROUTE+"/envio-rastreado"} component={EnvioRastreado} />   
                    <Route exact path={c.REPORT_ROUTE + "/verifica-montreal"} component={EnvioVerificaMontreal} />
                    <Route exact path={c.REPORT_ROUTE + "/verifica-montreal-toi"} component={envioVerificaMontrealToi} />
                    <Route exact path={c.REPORT_ROUTE + "/download-relatorio"} component={downloadRelatorio} />
                    <Route exact path={c.REPORT_ROUTE + "/graficos"} component={Graficos} />
                
                    <Route component={Error404} />                   
                </Switch>

            </PrivateLayout>
        );
    }  
}

function mapStateToProps(state)
{
    return { auth: state.auth };
}
function mapDispatchToProps(dispatch)
{
    return { actions: { } };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Relatorio));
